import * as Sentry from '@sentry/browser';

import { getConfig, isFedramp, isIsolatedCloud } from '@adminhub/config';

import { isSentryUserContextEnabled } from './feature-flag';

export const initSentry = (): ReturnType<typeof Sentry.init> => Sentry.init(getConfig().sentryConfig);

export interface SentryUserContext {
  id: string;
  email?: string;
  name?: string;
  locale?: string;
}

export const setSentryUser = (user: SentryUserContext | null): void => {
  if (!isSentryUserContextEnabled() || isFedramp() || isIsolatedCloud() || !user) {
    Sentry.setUser(null);

    return;
  }

  // Set user context with Atlassian user ID
  Sentry.setUser({
    id: user.id,
  });
};
